// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3Lg-n","col":"Table_col__33J3B","fulfillmentStatus":"Table_fulfillmentStatus__3QaPT","emailCol":"Table_emailCol__zBCMP"};